import { UpdateQuoteLineResponse } from '@snap-types/features/alpha/actions/update-quote-line';
import { alphaQuoteLineStrictCalculatedDataSchema } from '@snap-types/models/alpha-quote-line';
import { alphaQuotePriceStrictCalculatedDataSchema } from '@snap-types/models/alpha-quote-price';
import z from 'zod';

const strictCalculatedData = z.object({
  ...alphaQuoteLineStrictCalculatedDataSchema.shape,
  quotePrices: z.array(alphaQuotePriceStrictCalculatedDataSchema),
});

export function buildCalculatedData(input: UpdateQuoteLineResponse) {
  const calculatedData = strictCalculatedData.safeParse(input);

  if (!calculatedData.success) {
    return null;
  }

  return calculatedData.data;
}
